export class UserGroupsDisabledError {}
export class NoRightsToManageAccountSettingsError {}
export class GroupExistsError {}


// WEBPACK FOOTER //
// ./web/js/groupManagement/errors.js